export const URL_GET_MODIFIER_LIST = "/v1/orderonline/item/item-modifier/list"
export const URL_CREATE_MODIFIER = "/v1/orderonline/item/item-modifier/create"
export const URL_UPDATE_MODIFIER = "/v1/orderonline/item/item-modifier/update"
export const URL_DELETE_MODIFIER = "/v1/orderonline/item/item-modifier/delete"
